<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">Reprocess</h1>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <ppl-correction-line-filter (search)="onSearch($event)" (clear)="onClear()"></ppl-correction-line-filter>
                    <p><strong>Note:</strong></p>
                    <ul>
                        <li>Lists denied and good to pay lines that have not been sent to NAV.</li>
                        <li><strong>Reprocess</strong> sends the selected lines through processing again. Lines already
                            sent to NAV are not reprocessed; use <strong>NAV Reset</strong> for those.</li>
                    </ul>
                </div>
                <div class="table-style">
                    @if (hasSearched) {
                    <ppl-list-table [cols]="cols" [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [data]="lines" [customDataLoaded]="true" [enableActions]="false"
                        [gridTitle]="false" [pagination]="true" [loadPage]="true" (onPageLoad)="onPageLoad($event)"
                        [actionButtons]="actionButtons" [enablePageActions]="!isReadOnly"
                        [listButton]="isReadOnly ? [] : buttons" (actionInvoked)="gridAction($event)">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning">Search by Provider PPL ID or Participant PPL ID to see lines.</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ppl-correction-notes-dialog [(visible)]="showReprocessPopup" title="Reprocess" okText="Reprocess"
    [message]="selectedLines.length + ' selected line(s) will be reprocessed. Lines already sent to NAV will not be reprocessed.'"
    placeholder="Reason for reprocessing" (confirmed)="submitReprocess($event)">
</ppl-correction-notes-dialog>
